import { render, staticRenderFns } from "./sub-certification.vue?vue&type=template&id=868c36f0&scoped=true&"
import script from "./sub-certification.vue?vue&type=script&lang=js&"
export * from "./sub-certification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868c36f0",
  null
  
)

export default component.exports